// Renders the currently-bound dossier in the taskpane. Three states:
//   - 'auto'    : auto-matched (score >= threshold) — shows confidence chip
//   - 'manual'  : user picked from picker — no chip (it's their choice)
//   - 'unbound' : no match found / nothing picked — shows "kies dossier" CTA

import type { CandidateCase, SearchResultCase } from "../../lib/cases";
import { sourceLabel } from "../../lib/cases";

export type BoundCase =
  | { kind: "auto"; case: CandidateCase }
  | { kind: "manual"; case: CandidateCase | SearchResultCase };

interface CaseContextProps {
  bound: BoundCase | null;
  onChangeRequest: () => void;
}

export function CaseContext({ bound, onChangeRequest }: CaseContextProps) {
  if (!bound) {
    return (
      <div className="rounded border border-dashed border-chrome-border bg-white p-3 space-y-2">
        <p className="text-sm text-chrome-text">Geen dossier gekoppeld aan deze mail.</p>
        <button
          type="button"
          onClick={onChangeRequest}
          className="text-xs font-medium text-accent hover:text-accent-hover"
        >
          Kies dossier handmatig →
        </button>
      </div>
    );
  }

  const c = bound.case;
  const isAuto = bound.kind === "auto";
  const reasons = isAuto ? (bound.case as CandidateCase).reasons : [];
  const primarySource = isAuto ? (bound.case as CandidateCase).primarySource : null;

  return (
    <div className="rounded border border-chrome-border bg-white p-3 space-y-2">
      <div className="flex items-start gap-2">
        <div className="flex-1 min-w-0">
          <div className="text-sm font-medium truncate" title={c.caseTitle}>{c.caseTitle}</div>
          <div className="text-xs text-chrome-subtle truncate">
            {c.matterNumber ?? "— geen dossiernummer"}
          </div>
        </div>
        {isAuto && primarySource && (
          <span
            className="shrink-0 rounded-full bg-accent/10 px-2 py-0.5 text-[10px] font-medium text-accent"
            title={reasons.join(" · ")}
          >
            {sourceLabel(primarySource)}
          </span>
        )}
      </div>
      <button
        type="button"
        onClick={onChangeRequest}
        className="text-xs text-chrome-subtle hover:text-chrome-text underline-offset-2 hover:underline"
      >
        Wijzig dossier
      </button>
    </div>
  );
}
